import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';

import { View } from '@klarna/bubble-ui';

const borderStyles = (hasFooterLink, hasTitle) => ({
  boxShadow: '0px 0px 7px 0px rgba(52,52,52,0.2)',
  padding: `${hasTitle ? '25' : '10'}px 25px ${hasFooterLink ? '15' : '40'}px 25px`,
});

const Card = ({
  children,
  extraStyles = {},
  numberOfColumns = 4,
  hasFooterLink = false,
  hasTitle = false,
  ...props
}) => {
  const safeChildren = (Array.isArray(children) ? children.flat() : [children]).filter(node =>
    React.isValidElement(node),
  );

  const style = { ...borderStyles(hasFooterLink, hasTitle), ...extraStyles };

  return (
    <View style={style}>
      {safeChildren.map((child, i) => cloneElement(child, { ...props, key: i }))}
    </View>
  );
};

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  extraStyles: PropTypes.object,
  hasFooterLink: PropTypes.bool,
  hasTitle: PropTypes.bool,
  numberOfColumns: PropTypes.number,
};

export default Card;
